export default {
  meta: {
    title: '模型配置',
    parentPath: ['/location'],
    breadcrumbs: {
      path: ['/location/surroundmodelconfig'],
      name: ['模型管理'],
    },
  },
};
